import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/userActions';
import * as followActions from '../../actions/followActions';
import PageContainer from '../Global/Containers/PageContainer';
import MaxWidthContainer from '../Global/Containers/MaxWidthContainer';
import TrainingGroundHero from './TrainingGroundHero';
import AgeGroupCTA from './AgeGroupCTA';
import CuratedFavourites from './CuratedFavourites';
import TrainingGroundTeaserList from './TrainingGroundTeaserList';
import TrainingGroundFeaturePromos from './TrainingGroundFeaturePromos';
import PopularSearches from './PopularSearches';

class TrainingGroundPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ``,
      searchLoading: false,
      ageGroups: [],
      ageGroupSubmitTimer: null,
      changeAgePreferencesSubmitting: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loggedInUser.age_groupings !== nextProps.loggedInUser.age_groupings) {
      this.setState({ ageGroups: nextProps.loggedInUser.age_groupings, changeAgePreferencesSubmitting: false });
    }

    if (this.props.contentFeed !== nextProps.contentFeed) {
      // Statement used if User API returns before content (usual case)
      this.callLoggedInOnlyAPIs(nextProps);
    } else if (this.props.loggedInUser !== nextProps.loggedInUser) {
      // Statement used if User API returns after content (rare case)
      this.callLoggedInOnlyAPIs(nextProps);
    }
  }

  callLoggedInOnlyAPIs = (nextProps) => {
    if (nextProps.loggedInUser.id && nextProps.contentFeed.Favourites.author) {
      this.props.actions.doIFollow([nextProps.contentFeed.Favourites.author.id]);
    }
  }

  handleSearchTermChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.setState({ searchLoading: true });
    window.location.href = `/search?term=${this.state.searchTerm}`;
  }

  handleAgeGroupChange = (e) => {
    // There is no submit button on the age group form (no other reason other than I couldn't get it to look good) so we auto-submit this form after an allotted timeframe
    // If the user changes age we want to reset the timer
    clearTimeout(this.state.ageGroupSubmitTimer);

    let newArray;
    const valueAsInt = parseInt(e.target.value, 0);
    if (this.state.ageGroups.filter(option => option === valueAsInt).length > 0) {
      // Remove from the list
      const filteredArray = this.state.ageGroups.filter(option => option !== valueAsInt);
      newArray = filteredArray;
    } else {
      // Add to the list
      newArray = [valueAsInt, ...this.state.ageGroups];
    }

    // Start the timer
    this.setState({
      ageGroups: newArray,
      ageGroupSubmitTimer: setTimeout(() => this.submitAgeGroupPreferences(newArray), 1500),
    });
  }

  submitAgeGroupPreferences = (ageGroups) => {
    this.setState({ changeAgePreferencesSubmitting: true });
    this.props.actions.updateCoachAgePreferences(ageGroups);
  }

  handleFollowCuratorClick = (action) => {
    const curatorId = this.props.contentFeed.Favourites.author.id;
    if (action === `follow`) {
      this.props.actions.followUser(curatorId);
    } else {
      this.props.actions.unfollowUser(curatorId);
    }
  }

  render() {
    const { organisation, loggedInUser, contentFeed, doIFollow, trendingSearches, popularSearches } = this.props;
    const { searchTerm, searchLoading, ageGroups, changeAgePreferencesSubmitting } = this.state;
    const { loading, Recommended, Favourites, Latest } = contentFeed;

    const recommendedList = Recommended.slice(0, 4);
    const latestList = Latest.slice(0, 8);
    
    return (
      <PageContainer classes="training-ground-page bg-white">
        <TrainingGroundHero 
          heroImage={organisation.lpHeroImage}
          orgName={organisation.name}
          quote={organisation.lpQuote}
          searchTerm={searchTerm}
          onSearchTermChange={this.handleSearchTermChange} 
          onSearchSubmit={this.handleSearchSubmit}
          searchLoading={searchLoading}
          trendingResults={trendingSearches.results}
          trendingLoading={trendingSearches.loading}
        />
        <PopularSearches presetSearches={popularSearches.preset_searches} active={popularSearches.active} />

        <MaxWidthContainer>
          {(loggedInUser.age_groupings === [] || loggedInUser.notLoggedIn) && (
            <AgeGroupCTA loggedInUser={loggedInUser} onChange={this.handleAgeGroupChange} values={ageGroups} submitting={changeAgePreferencesSubmitting} />
          )}

          <CuratedFavourites data={Favourites} loading={loading} loggedInUser={loggedInUser} doIFollowCurator={doIFollow} onFollowClick={this.handleFollowCuratorClick} />
          <TrainingGroundTeaserList title="Recommended For You" list={recommendedList} loading={loading} userLocation={loggedInUser.web_location} />
          <TrainingGroundTeaserList title="Latest Coaching Videos" list={latestList} loading={loading} userLocation={loggedInUser.web_location} showThumbnails />
          <TrainingGroundFeaturePromos />
        </MaxWidthContainer>
      </PageContainer>
    );
  }
}

TrainingGroundPage.propTypes = {
  organisation: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object.isRequired,
  contentFeed: PropTypes.object.isRequired,
  trendingSearches: PropTypes.object.isRequired,
  doIFollow: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  popularSearches: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    loggedInUser: state.loggedInUser,
    contentFeed: state.trainingGround.contentFeed,
    popularSearches: state.trainingGround.popularSearches,
    doIFollow: state.doIFollow,
    trendingSearches: state.search.trendingSearches,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, userActions, followActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingGroundPage);



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/TrainingGroundPage.js